import toArray from 'data-uri-to-u8';
import exif from 'exif-component';
import rotate from './exif-rotate';

const orientations = {
  'top-left': 1,
  'top-right': 2,
  'bottom-right': 3,
  'bottom-left': 4,
  'left-top': 5,
  'right-top': 6,
  'right-bottom': 7,
  'left-bottom': 8,
};

const urlToImage = (url: string, fn: (image: HTMLImageElement) => void) => {
  const img = new Image();
  if (fn) {
    img.onload = fn.bind(null, img);
  }
  img.src = url;
  return img;
};

const fixImageOrientation = (url: string, fn: (imageUrl: string) => void) => {
  const buf = toArray(url);
  let categories: any = {};

  try {
    categories = exif(buf.buffer);
  } catch (err) {}

  const hasOrientationValue =
    categories.Orientation && typeof categories.Orientation.value === 'number';
  let orientation = 0;

  if (hasOrientationValue) {
    orientation = categories.Orientation.value;
  } else if ((orientations as any)[categories.orientation]) {
    orientation = (orientations as any)[categories.orientation];
  }

  if (orientation === 0) {
    return fn(url);
  }

  urlToImage(url, (image) => {
    fn(rotate(image, orientation));
  });
};

export default fixImageOrientation;
